import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import queryReducer from "./queryReducer";


export default combineReducers({
    login: loginReducer,
    query: queryReducer
})